import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { authorizeRole, ERROR_PAGES } from '@/constant/global/global.constant';
import { getRole } from '@/constant/users/user.constant';
import { useNavigate } from 'react-router-dom';
import _ from 'lodash';
import { SETTINGS_KEY } from '@/utils/settings';
import { AppButton } from '@/components/atoms/AppButton';
import { Text, Body } from '@/components';
import { LuLogOut } from 'react-icons/lu';
import { APP_BG } from '@/constant/theme/colors.constant';
import { tid } from '@/utils/testId';

const Forbidden = () => {
  const { logout } = useAuth0();
  const navigate = useNavigate();

  const userHasHubAccess = _.includes(authorizeRole.PORTAL.READ, getRole());

  useEffect(() => {
    if (userHasHubAccess) navigate('/dashboard', { replace: true });
  }, [userHasHubAccess]);

  if (userHasHubAccess) return null;

  const handleLogout = () => {
    const s = localStorage.getItem(SETTINGS_KEY);
    localStorage.clear();
    sessionStorage.clear();
    if (s) localStorage.setItem(SETTINGS_KEY, s);
    logout({ logoutParams: { returnTo: window.location.origin } });
  };

  return (
    <div
      className={`min-h-screen flex flex-col items-center justify-center ${APP_BG.canvas} px-4`}
    >
      <div className="absolute w-[500px] h-[500px] rounded-full bg-primary/10 dark:bg-primary/5 blur-3xl pointer-events-none" />
      <div className="relative z-10 flex flex-col items-center text-center max-w-lg gap-6">
        <div className="relative select-none">
          <span
            className="text-[10rem] leading-none font-black tracking-tighter bg-clip-text text-transparent"
            style={{
              backgroundImage:
                'linear-gradient(135deg, var(--color-primary), var(--color-secondary), var(--color-tertiary))',
            }}
          >
            403
          </span>
          <span
            className="absolute left-0 right-0 -bottom-4 text-[10rem] leading-none font-black tracking-tighter bg-clip-text text-transparent opacity-10 scale-y-[-1] blur-sm pointer-events-none"
            style={{
              backgroundImage:
                'linear-gradient(135deg, var(--color-primary), var(--color-secondary))',
            }}
            aria-hidden
          >
            403
          </span>
        </div>
        <div
          className="h-1 w-20 rounded-full"
          style={{
            background:
              'linear-gradient(90deg, var(--color-primary), var(--color-tertiary))',
          }}
        />
        <div className="flex flex-col gap-2">
          <Text as="h1" size="3xl" weight="bold" color="default">
            {ERROR_PAGES.FORBIDDEN.TITLE}
          </Text>
          <Body color="muted" className="leading-relaxed">
            {ERROR_PAGES.FORBIDDEN.BODY}
          </Body>
        </div>
        <AppButton
          variant="primary"
          size="md"
          shape="default"
          elevation={2}
          icon={<LuLogOut />}
          onClick={handleLogout}
          className="!rounded-xl"
          data-testid={tid('forbidden-sign-out-btn')}
        >
          {ERROR_PAGES.FORBIDDEN.SIGN_OUT}
        </AppButton>
      </div>
    </div>
  );
};

export default Forbidden;
